import { createSelector } from "reselect";

import { alphabeticalSortBySelector } from "helpers/sort";
import { AgentActionsNames, IAgent, IWithAgentsState, selectAgents } from "store/entities/agents";
import { IWithRequestsState, createRequestFetchingSelector } from "store/requests/selectors";

import { AgentsViewActionsNames } from "./actions";
import { ILiveChatAgent, ISort } from "./interfaces";
import { IAgentsViewState } from "./reducer";

export interface IWithAgentsViewState {
  views: {
    agents: IAgentsViewState;
  };
}

export function getAgentsState(state: IWithAgentsViewState): IAgentsViewState {
  return state.views.agents;
}

export function getSelectedAgentId(state: IWithAgentsViewState): string {
  return getAgentsState(state).selectedAgentId;
}

export function getFocusedColumn(state: IWithAgentsViewState): number {
  return getAgentsState(state).focusedColumn;
}

export function getListSorting(state: IWithAgentsViewState): ISort {
  return getAgentsState(state).sort;
}

export function getSortLoggedInAgentOnTop(state: IWithAgentsViewState): boolean {
  return getAgentsState(state).sortLoggedInAgentOnTop;
}

export const getIsSavingAgent = (state: IWithRequestsState): boolean =>
  createRequestFetchingSelector([AgentsViewActionsNames.UPDATE_AGENT])(state);

export const getIsSavingAgents = (state: IWithRequestsState): boolean =>
  createRequestFetchingSelector([AgentActionsNames.CREATE_BATCH])(state);

export const getAreAgentsSaved = (state: IWithRequestsState): boolean =>
  createRequestFetchingSelector([AgentActionsNames.CREATE_BATCH])(state, true);

function selectLiveChatAgents(state: IWithAgentsViewState): ILiveChatAgent[] | null {
  return state.views.agents.livechatAgents;
}

const selectLiveChatAgentsToImport = createSelector<
  // @ts-expect-error TS(2558)
  IWithAgentsViewState & IWithAgentsState,
  ILiveChatAgent[],
  Record<string, IAgent>,
  ILiveChatAgent[]
>(
  selectLiveChatAgents,
  selectAgents,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (liveChatAgents: any, helpDeskAgents: any) => {
    if (liveChatAgents === null) {
      return null;
    }
    const uniqueAgents = liveChatAgents.filter(
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (liveChatAgent: any) =>
        !Object.keys(helpDeskAgents).find(agentId => helpDeskAgents[agentId].email === liveChatAgent.email)
    );
    if (uniqueAgents.length === 0) {
      return null;
    }
    return uniqueAgents;
  }
);

// @ts-expect-error TS(2769)
export const selectLiveChatAgentsToImportAlphabetically = createSelector(
  selectLiveChatAgentsToImport,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (agents: any) => {
    if (!agents) {
      return null;
    }
    // @ts-expect-error TS(2571)
    return Object.values(agents).sort(alphabeticalSortBySelector(agent => agent.name));
  }
);

export function selectIsImportingLiveChatAgent(state: IWithRequestsState): boolean {
  return createRequestFetchingSelector(["VIEWS/AGENTS/IMPORT_LIVECHAT_AGENT"])(state);
}
